var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 6.655C3.33655 6.2173 3.51166 5.79836 3.82102 5.4887C4.13037 5.17903 4.54913 5.00349 4.98683 5H35.0135C35.9268 5 36.6668 5.74167 36.6668 6.655V33.345C36.6638 33.7827 36.4887 34.2016 36.1793 34.5113C35.87 34.821 35.4512 34.9965 35.0135 35H4.98683C4.54819 34.9996 4.12766 34.825 3.81765 34.5147C3.50763 34.2043 3.3335 33.7836 3.3335 33.345V6.655ZM6.66683 8.33333V31.6667H33.3335V8.33333H6.66683ZM20.0002 20.2833V10H28.3335V13.3333H23.3335V25C23.3329 26.0613 22.9947 27.0948 22.3678 27.9511C21.7408 28.8074 20.8577 29.442 19.8462 29.7631C18.8346 30.0841 17.7472 30.075 16.7411 29.737C15.7351 29.3991 14.8628 28.7497 14.2503 27.8831C13.6378 27.0164 13.3169 25.9773 13.3342 24.9162C13.3514 23.855 13.7058 22.8269 14.3462 21.9806C14.9865 21.1343 15.8795 20.5136 16.8959 20.2085C17.9124 19.9034 18.9996 19.9296 20.0002 20.2833V20.2833Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/IconMusic.765820b3.svg";
export { ForwardRef as ReactComponent };